<template>
  <div id="pass-preview-container">
    <div
      v-if="currentPass.pass_image"
      ref="pass"
      id="pass-preview"
      :style="{ 'background-image': 'url(' + this.passTypeSrc + ')' }"
    >
      <div
        id="dates"
        v-if="isThirtyDayPass"
      >
        <div class="date">{{ startDate }}</div>
        <div class="date">{{ endDate }}</div>

      </div>
      <div id="bottom-details">
        <div id="left-info">
          <b id="barcode-number">{{ this.currentPass.barcode }}</b>

          <div id="name">
            <span>{{ this.firstName }}</span>
            <br />
            <span>{{ this.lastName }}</span>
          </div>
        </div>

        <div
          id="pass-holder-image-container"
          v-if="this.currentPass.image"
        > <img
            :src="passHolderImage"
            id="pass-holder-image"
          >
        </div>
      </div>

      <div id="barcode">
        {{ this.currentPass.barcode }}
      </div>
    </div>

    <div v-else>
       <b-alert variant="error" show>Please upload an image for the pass type before printing</b-alert>
    </div>
  </div>
</template>

<script>
import config from "../constants";
import moment from "moment";
import api from "../api";

export default {
  props: {
    currentPass: Object
  },
  computed: {
    passTypeSrc() {
      return `${config.passTypePhotosUrl}/${this.currentPass.pass_image}`;
    },
    passHolderImage() {
      return `${config.profilePhotosUrl}/${this.currentPass.image}`
    },
    firstName() {
      return this.currentPass.name.split(" ")[0];
    },
    lastName() {
      const splittedUsername = this.currentPass.name.split(" ");

      if (splittedUsername.length === 1) return "";

      return splittedUsername.slice(1).join(" ");
    },
    isThirtyDayPass() {
      return this.currentPass.pass_type === '30 Day Pass';
    },
    startDate() {
      return moment(this.currentPass.expiry_date)
        .subtract(30, "days")
        .format("D/M/YY");
    },
    endDate() {
      return moment(this.currentPass.expiry_date).format("D/M/YY");
    }
  }
};
</script>

<style scoped>
#pass-preview {
  margin: 0 auto;
  display: block;
  background-size: cover;
  width: 213px;
  height: 305px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

#bottom-details {
  width: 100%;
  display: flex;
  height: 80px;
}

#pass-holder-image-container {
  margin-left: auto;
}

#pass-holder-image {
  margin-left: auto;
  margin-bottom: 20px;
  margin-right: 20px;
  width: 4rem;
}

#barcode {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  align-self: flex-end;
  font-family: "Libre Barcode 39 Extended", cursive;
  font-size: 3rem;
  margin-bottom: -20px;
}

#name {
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
  margin-left: 20px;
  color: #1baea9 !important;
  -webkit-print-color-adjust: exact !important;
  color-adjust: exact !important;
  font-weight: 500;
  font-size: 0.9rem;
  margin-top: 20px;
}

#barcode-number {
  -webkit-print-color-adjust: exact !important;
  color-adjust: exact !important;
  color: #1baea9 !important;
  font-size: 0.9rem;
  margin-left: 20px;
}

#dates {
  margin-bottom: auto;
  text-align: center;
  color: #1baea9;
  font-size: 1rem;
  font-weight: 500;
}

.date {
  width: 49%;
  display: inline-block;
}


@media print {
  #pass-preview-container {
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    margin: 0;
    margin: 0;
  }

  #dates {
    color-adjust: exact !important;
    -webkit-print-color-adjust: exact !important;
    color: rgb(250, 245, 242) !important;
    font-size: 1.1rem;
  }

  #barcode-number {
    color-adjust: exact !important;
    -webkit-print-color-adjust: exact !important;
    color: rgb(250, 245, 242) !important;
    font-size: 1.1rem;
  }

  #name {
    color: rgb(250, 245, 242) !important;
    color-adjust: exact !important;
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact;
    font-size: 1.1rem;
    margin-top: 40px;
  }

  #bottom-details {
    margin-bottom: 70px;
  }

  #pass-preview {
    color-adjust: exact;
    width: 100%;
    height: 100%;
  }

  #pass-holder-image {
    color-adjust: exact;
    width: 100px;
  }

  @page {
    margin: 0;
  }



  .date {
    font-size: 1.1rem;
  }

  #barcode {
    margin-bottom: -27px;
  }
}

@media print {
    @page {
      size:55mm 85mm;
      margin: 0;
    }
}
</style>

<style>
@media print {
  html, body {
    height: 85mm !important;
    max-height: 85mm !important;
    overflow: hidden !important;
  }
  body > * {
    max-height: 85mm !important;
    overflow: hidden !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PrintModalContents.vue